export default __webpack_public_path__ + "video-and-animation.8ce43f4b.png";